const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
// @commons
const { formatText } = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKModal = require('components/commons/OKModal/OKModal');

class FilterContracts extends React.Component {

    constructor(params) {
        super(params);

        this.state = {
            interventionSelected : this.props.interventionSelected || -1,
            interventionValue : this.props.interventionValue || ''
        }

        this.handleInterventionChange = this.handleInterventionChange.bind(this);
        this.handleSubmitIntervention = this.handleSubmitIntervention.bind(this);
    }

    getInterventionSelect() {
        const options = this.props.interventions.valueSeq().map((intervention, index) => {
            return {
                index,
                value: index,
                label: formatText(`interventionTypes-${intervention}`)
            }
        });

        return options.toJS();
    }

    handleInterventionChange(intervention) {
        this.setState({
            interventionSelected : intervention.index,
            interventionValue : intervention.value,
            interventionLabel : intervention.label
        });
    }

    handleSubmitIntervention() {
        this.props.onFilterByIntervention(this.state.interventionValue, this.state.interventionLabel);
    }

    render() {
        const { isOpen, onClose } = this.props;
        const interventionTypeText = formatText('profileContracts-interventionType');
        const placeholderText = formatText('profileContracts-placeholderText');
        const modalContent = (
            <OKSelect
                clearable={false}
                label={interventionTypeText}
                matchPos="start"
                matchProp="label"
                noResultsText="no results"
                onChange={this.handleInterventionChange}
                options={this.getInterventionSelect()}
                placeholder={placeholderText}
                value={this.state.interventionSelected}
            />
        );
        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onClose}
                onPrimaryButtonClick={this.handleSubmitIntervention}
                onSecondaryButtonClick={onClose}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="profileContracts-filtersTitle"
            />
        );
    }
}

FilterContracts.propTypes = {
    interventions: PropTypes.object.isRequired,
    interventionSelected: PropTypes.number,
    interventionValue: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onFilterByIntervention: PropTypes.func.isRequired,
}

module.exports = FilterContracts;
module.exports.FilterContracts = connect(null, {})(FilterContracts);